import Cookies from 'universal-cookie';

export const COOKIE_AGREE = 'privacy-policy-cookie-consent';
export const COOKIE_EXACT_TIME = 'exact-time';
export const COOKIE_USER_ID = 'user-id';
export const COOKIE_SESSION_ID = 'session-id';
export const YEAR_IN_SECONDS = 31536000;
export const NEXT_YEAR = new Date(new Date().setFullYear(new Date().getFullYear() + 1));
const cookies = new Cookies();

export const getAnalyticsData = async () => {
  const exactTime = Date.now().toString();

  return {
    userID: await getCookie(COOKIE_USER_ID, exactTime),
    sessionID: await getCookie(COOKIE_SESSION_ID, exactTime),
    exactTime: await generateValue(COOKIE_EXACT_TIME, exactTime),
  };
};

export const getCookie = (key: string, defaultValue?: string) => {
  const value = cookies.get(key);

  return value || generateValue(key, defaultValue);
};

const generateValue = async (key: string, value = '') => {
  switch (key) {
    case COOKIE_EXACT_TIME:
      return setCookies(key, value, true);
    case COOKIE_SESSION_ID:
      return setCookies(key, value, true);
    case COOKIE_USER_ID:
      return setCookies(key, value);
    default:
      return '';
  }
};

export const setCookies = async (key: string, value: string, isSessionData?: boolean) => {
  cookies.set(`${key}`, `${value}`, isSessionData ? { path: '/' } : { path: '/', maxAge: YEAR_IN_SECONDS });

  return value;
};

export const removeCookies = async (key: string) => {
  cookies.remove(key);
};
